import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import ProverReleaseApp from './tenants/prover/release/ProverReleaseApp.jsx'
import './index.css'
import './tenants/santaclara/landing/public/santa-clara.css'

const hostname = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : ''
const isProverHost = hostname === 'prover.com.py'
  || hostname === 'www.prover.com.py'
  || hostname.includes('prover-web')
  || hostname.startsWith('prover-')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {isProverHost ? <ProverReleaseApp /> : <App />}
  </React.StrictMode>,
)
